<template>
  <div class="tooltiped-cell">
    <v-tooltip class="tooltiped-cell__tooltip" bottom :disabled="elements.length <= 2">
      <template v-slot:activator="{ on }">
        <span v-on="on">{{ visibleElements }}</span>
      </template>
      <div class="tooltiped-cell__tooltip-content">
        <div
          v-for="(element, index) in elements"
          :key="index"
          class="tooltiped-cell__tooltip-element"
        >
          {{ element }}
        </div>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      required: true,
    },
  },

  computed: {
    visibleElements() {
      let elementsString = this.elements.slice(0, 2).join(', ');

      if (this.elements.length > 2) {
        const invisibleFieldsNumber = this.elements.length - 2;
        elementsString += ` (${invisibleFieldsNumber})...`;
      }

      return elementsString;
    },
  },
};
</script>

<style lang="scss" scoped></style>
